(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteDeleteController',ReportExecuteDeleteController);

    ReportExecuteDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReportExecute'];

    function ReportExecuteDeleteController($uibModalInstance, entity, ReportExecute) {
        var vm = this;

        vm.reportExecute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReportExecute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
